import { CaseStatus } from "../generated/resolvers";

export type InactiveCaseStatusesType = CaseStatus.Complete | CaseStatus.NotProceeding | CaseStatus.Referred | CaseStatus.ImportedComplete;

export const inactiveCaseStatuses = [
  CaseStatus.Complete,
  CaseStatus.NotProceeding,
  CaseStatus.Referred,
  CaseStatus.ImportedComplete
];